module.exports = __webpack_public_path__ + "assets/election_grey.1830e556.svg";